import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import * as _ from 'lodash';
import { NgForm } from '@angular/forms';
declare var $: JQueryStatic;

import { CommonApiService } from '../web-api-services/common.service';
import { AideModel } from '../models/AideModel';
import { NotificationService } from '../services/notification.service';
import { AideService } from './aide.service';
import { ConfigurationService } from '../services/configuration.service';

@Component({
  selector: 'aide-edit',
  templateUrl: './aide-edit.component.html',
  styleUrl: './aide-edit.component.css',
  providers: [DialogService],
})
export class AideEditComponent implements OnInit {
  aide: AideModel = null;
  saveDisabled: boolean = false;
  keepOpen: boolean = true;
  tinymceInit: any = {};

  constructor(
    private commonApiService: CommonApiService,
    private notificationService: NotificationService,
    public dialogService: DialogService,
    private confirmationService: ConfirmationService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private aideService: AideService,
    public configurationService: ConfigurationService,
  ) {
    this.tinymceInit = configurationService.gettinymceInit(this.configurationService.typesMedia.imageAide);
  }

  ngOnInit() {
    this.aide = this.config.data.aide;
  }

  setKeepOpen(keepOpen: boolean): boolean {
    this.keepOpen = keepOpen;
    return true;
  }

  formSubmit(form: NgForm) {
    if (!this.saveDisabled) {
      this.saveDisabled = true;

      if (form.valid) {
        this.save();
      } else {
        console.log(form);
        this.notificationService.error('Enregistrement impossible. Veuillez contrôler les champs en rouge.');
        this.saveDisabled = false;
      }
    }
  }

  save() {
    this.commonApiService.saveAide(this.aide).subscribe(
      result => {
        if (result) {
          this.aideService.updateAide(this.aide);
          this.notificationService.success('Enregistrement effectué avec succès');
          if (this.keepOpen) {
            this.saveDisabled = false;
            if (this.config.data.updateMethod) {
              this.config.data.updateMethod(this.aide);
            }
          } else {
            this.ref.close(this.aide);
          }
        } else {
          this.notificationService.error("Une erreur est survenue lors de l'enregistrement");
        }
      },
      error => {
        console.log(error);
        this.saveDisabled = false;
      },
    );
  }

  delete() {
    this.confirmationService.confirm({
      message: "Confirmez-vous la suppression de l'aide ?",
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.aideService.deleteAide(this.aide);
        this.aide.Aide = null;
        this.commonApiService.saveAide(this.aide).subscribe(
          result => {
            if (result) {
              this.notificationService.success('Suppression effectuée avec succès');
              this.ref.close(this.aide);
            } else {
              this.notificationService.error('Une erreur est survenue lors de la suppression');
            }
          },
          error => {
            console.log(error);
            this.saveDisabled = false;
          },
        );
      },
      reject: () => {},
    });
  }

  cancel() {
    this.ref.close(null);
  }
}
